import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const InputSelect = ({
  className, error, label, name, ...rest
}) => (
  <div className={`input-type-style ${className}`}>
    <Select
      className={error ? 'input-error' : 'dropdown-style no-border'}
      classNamePrefix="dropdown"
      isClearable
      placeholder="Buscar..."
      loadingMessage={() => 'Carregando...'}
      noOptionsMessage={() => 'Nenhum resultado encontrado'}
      cacheOptions={false}
      name={name}
      {...rest}
    />
    {label && (
      <label htmlFor={name} className="input-label-style">
        {label}
      </label>
    )}
    {error && <span className="input-helper">{error}</span>}
  </div>
);

InputSelect.propTypes = {
  className: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  label: PropTypes.string,
  name: PropTypes.string,
};

InputSelect.defaultProps = {
  className: 'w-100',
  error: '',
  label: '',
  name: '',
};

export default InputSelect;
